export default __webpack_public_path__ + "static/media/fireflink_finder.d882525d.svg";